import React from 'react';
import { MdKeyboardArrowDown as DownArrow } from 'react-icons/md';
import { MdKeyboardArrowUp as UpArrow } from 'react-icons/md';
import { colors } from 'helpers/ColorHelper';

export default (props) => (
  <div
    className="row"
    style={{
      margin: props.paddingMargin || '0px -5px 5px',
      backgroundColor: props.backgroundColor || colors.LIGHT_GRAY,
      padding: props.padding || '5px 10px',
      fontSize: '14px',
      fontWeight: '800',
      cursor: 'pointer',
    }}
  >
    <div className="col-xs-12" style={{ textAlign: 'left', ...props.style }}>
      <span style={{ color: props.color, margin: '0', textAlign: props.textAlign || 'center' }}>
        {' '}
        {props.menuTitle}{' '}
      </span>
      <span
        style={{
          color: props.color,
          float: props.float || 'right',
          position: 'absolute',
          right: 0,
        }}
      >
        {props.isOpen && <UpArrow size={18} />}
        {!props.isOpen && <DownArrow size={18} />}
      </span>
    </div>
  </div>
);
